import React from "react";
import { CertificateCard } from "./CertificateCard";
import { StudentCertificatesProps } from "./types";
import { EmptyList } from "../Table/listTable/EmptyList";
import { DISPLAY, SPACING } from "../../Constants/Enums/styles.enum";
import { SectionHeader } from "../Header/SectionHeader";
import { Card } from "../card";

export const StudentCertificates: React.FC<StudentCertificatesProps> = ({
  studentCertificates,
}) => {
  const hasCertificates = studentCertificates && studentCertificates.length > 0;

  if (!hasCertificates) {
    return <EmptyList />;
  }

  const subHeaderText = `${studentCertificates.length} ${
    studentCertificates.length === 1 ? "certificate" : "certificates"
  } available`;

  return (
    <Card>
      <div>
        <SectionHeader
          headerText=" Student Certificates"
          subText={subHeaderText}
        />

        <div
          style={{
            display: DISPLAY.GRID,
            gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
            gap: SPACING.S20,
            width: "100%",
            marginTop: SPACING.S24,
          }}
        >
          {studentCertificates.map((certificate, index) => (
            <CertificateCard
              key={`certificate-${index}-${certificate.certificateName}`}
              certificate={certificate}
              index={index}
            />
          ))}
        </div>
      </div>
    </Card>
  );
};
